import * as types from "./actionTypes";

export function setError(errorMessage) {
  return { type: types.SET_ERROR, errorMessage };
}
